/**
 * --------------------------------------------------------------------------
 * Liander Bootstrap custom-file-input.js
 * --------------------------------------------------------------------------
 */

import {
  defineJQueryPlugin
} from '../../node_modules/bootstrap/js/src/util/index.js'
import EventHandler from '../../node_modules/bootstrap/js/src/dom/event-handler.js'
import SelectorEngine from '../../node_modules/bootstrap/js/src/dom/selector-engine.js'
import BaseComponent from '../../node_modules/bootstrap/js/src/base-component.js'

/**
 * Constants
 */

const NAME = 'customfileinput'
const DATA_KEY = 'lbs.custom-file-input'
const EVENT_KEY = `.${DATA_KEY}`
const DATA_API_KEY = '.data-api'

const FAKE_PATH = 'fakepath'
const FAKE_PATH_SEPARATOR = '\\'

const EVENT_RESET = 'reset'
const EVENT_CHANGE_DATA_API = `change${EVENT_KEY}${DATA_API_KEY}`

const SELECTOR_CUSTOM_FILE = '.custom-file'
const SELECTOR_CUSTOM_FILE_INPUT = '.custom-file-input'
const SELECTOR_CUSTOM_FILE_LABEL = '.custom-file-label'
const SELECTOR_FORM = 'form'

const Default = {}

const DefaultType = {}

/**
 * Class definition
 */

class CustomFileInput extends BaseComponent {
  constructor(element, config) {
    super(element, config)

    this._defaultText = ''

    this._init()
  }

  // Getters
  static get Default() {
    return Default
  }

  static get DefaultType() {
    return DefaultType
  }

  static get NAME() {
    return NAME
  }

  // Public
  onChange() {
    const label = this._getLabel()
    if (label) {
      const inputValue = this._getSelectedFiles()

      if (inputValue.length) {
        label.textContent = inputValue
      } else {
        this._restoreDefaultText()
      }
    }
  }

  reset() {
    this._restoreDefaultText()
  }

  // Private
  _init() {
    this._setDefaultText()
  }

  _getInput() {
    return SelectorEngine.findOne(SELECTOR_CUSTOM_FILE_INPUT, this._element)
  }

  _getLabel() {
    return SelectorEngine.findOne(SELECTOR_CUSTOM_FILE_LABEL, this._element)
  }

  _setDefaultText() {
    this._defaultText = this._getLabel().textContent
  }

  _getSelectedFiles() {
    const input = this._getInput()
    if (input.value.includes(FAKE_PATH)) {
      const splittedValue = input.value.split(FAKE_PATH_SEPARATOR)

      return splittedValue[splittedValue.length - 1]
    }

    return input.value
  }

  _restoreDefaultText() {
    const label = this._getLabel()

    if (label) {
      label.textContent = this._defaultText
    }
  }

  // Static

  static jQueryInterface(config) {
    return this.each(function () {
      const data = CustomFileInput.getOrCreateInstance(this, config)

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`)
        }

        data[config]()
      }
    })
  }
}

/**
 * Data API implementation
 */

EventHandler.on(document, EVENT_CHANGE_DATA_API, SELECTOR_CUSTOM_FILE_INPUT, event => {
  const targets = SelectorEngine.parents(event.delegateTarget, SELECTOR_CUSTOM_FILE)
  if (targets.length) {
    const customFile = CustomFileInput.getOrCreateInstance(targets[0])
    customFile.onChange()
  }
})

EventHandler.on(document, EVENT_RESET, SELECTOR_FORM, event => {
  const customfiles = SelectorEngine.find(SELECTOR_CUSTOM_FILE, event.delegateTarget)

  for (const customFile of customfiles) {
    const customFileInput = CustomFileInput.getOrCreateInstance(customFile)
    customFileInput.reset()
  }
})

/**
 * jQuery
 */

defineJQueryPlugin(CustomFileInput)

export default CustomFileInput
